import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import EmbedConfigurator from './pages/EmbedConfigurator';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Products from './pages/Products';
import ProductDetails from './pages/ProductDetails';
import Fields from './pages/Fields';
import Fabrics from './pages/Fabrics';
import Finishes from './pages/Finishes';
import Certifications from './pages/Certifications';
import Currencies from './pages/Currencies';
import Countries from './pages/Countries';
import Manufacturers from './pages/Manufacturers';
import FabricCoatings from './pages/FabricCoatings';
import Installations from './pages/Installations';
import Materials from './pages/Materials';
import Calculations from './pages/Calculations';
import FabricGrades from './pages/FabricGrades';
import FabricGradePricing from './pages/FabricGradePricing';
import Features from './pages/Features';
import Options from './pages/Options';
import Settings from './pages/Settings';
import Configurator from './pages/Configurator';
import Logs from './pages/Logs';
import BulkOperations from './pages/BulkOperations';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardLayout from './components/layout/DashboardLayout';

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      {/* Public, no-login storefront 3D configurator (embedded in Shopify iframe) */}
      <Route path="/embed/configurator" element={<EmbedConfigurator />} />
      <Route
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/:id" element={<ProductDetails />} />
        <Route path="/fields" element={<Fields />} />
        <Route path="/fabrics" element={<Fabrics />} />
        <Route path="/fabric-grades" element={<FabricGrades />} />
        <Route path="/fabric-grade-pricing" element={<FabricGradePricing />} />
        <Route path="/finishes" element={<Finishes />} />
        <Route path="/certifications" element={<Certifications />} />
        <Route path="/manufacturers" element={<Manufacturers />} />
        <Route path="/currencies" element={<Currencies />} />
        <Route path="/countries" element={<Countries />} />
        <Route path="/fabric-coatings" element={<FabricCoatings />} />
        <Route path="/installations" element={<Installations />} />
        <Route path="/materials" element={<Materials />} />
        <Route path="/calculations" element={<Calculations />} />
        <Route path="/features" element={<Features />} />
        <Route path="/options" element={<Options />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/configurator" element={<Configurator />} />
        <Route path="/bulk-operations" element={<BulkOperations />} />
        <Route path="/logs" element={<Logs />} />
        <Route path="/users" element={<Users />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default App;
